var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20.0195C40 31.0708 31.0456 40.0283 19.9983 40.0283C8.95098 40.0283 0 31.0708 0 20.0195C0 8.96828 8.95436 0.0107422 19.9983 0.0107422C31.0422 0.0107422 40 8.96828 40 20.0195Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H10V30H30V10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0014 20.3855C22.8586 20.3855 25.1942 18.0499 25.1942 15.1928C25.1942 12.3356 22.8586 10 20.0014 10C17.1442 10 14.8087 12.3356 14.8087 15.1928C14.8087 18.0499 17.1443 20.3855 20.0014 20.3855ZM28.913 24.5352C28.7769 24.195 28.5955 23.8776 28.3915 23.5828C27.3484 22.0408 25.7384 21.0204 23.9244 20.771C23.6976 20.7483 23.4482 20.7936 23.2668 20.9297C22.3144 21.6326 21.1806 21.9954 20.0014 21.9954C18.8223 21.9954 17.6885 21.6326 16.7361 20.9297C16.5547 20.7936 16.3053 20.7256 16.0785 20.771C14.2645 21.0204 12.6318 22.0408 11.6114 23.5828C11.4073 23.8776 11.2259 24.2177 11.0899 24.5352C11.0219 24.6712 11.0445 24.8299 11.1126 24.966C11.294 25.2835 11.5207 25.601 11.7248 25.873C12.0422 26.3039 12.3824 26.6894 12.7679 27.0522C13.0853 27.3696 13.4481 27.6644 13.811 27.9592C15.6024 29.2971 17.7566 30 19.9788 30C22.201 30 24.3552 29.297 26.1466 27.9592C26.5094 27.6871 26.8722 27.3696 27.1897 27.0522C27.5525 26.6894 27.9153 26.3039 28.2328 25.873C28.4595 25.5783 28.6636 25.2835 28.845 24.966C28.9583 24.8299 28.981 24.6712 28.913 24.5352Z",
    fill: "#0E344B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 41,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/userAvatar.c5bb45e901e9899fdbeee16d4605c77d.svg";
export { ForwardRef as ReactComponent };